<div id="wrapper" class="center">
  <div id="dialog" class="center">
    <p>{{publicservice.Texts.Texts["six-digit1"]}}</p><br>
    <div id="sendagain"><a href="six-digit" [class]="key"
                           (click)="sendAgainClick()">{{publicservice.Texts.Texts["six-digit3"]}} </a></div>
    <div [class]="key2">{{getSecond()}}</div>
    <div id="form">
      <div class="confirmation-group d-flex">
        <input type="tel" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}"
               (keyup)="onDigitInput($event)" [(ngModel)]="publicservice.code1"/>
        <input type="tel" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}"
               (keyup)="onDigitInput($event)" [(ngModel)]="publicservice.code2"/>
        <input type="tel" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}"
               (keyup)="onDigitInput($event)" [(ngModel)]="publicservice.code3"/>
        <input type="tel" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}"
               (keyup)="onDigitInput($event)" [(ngModel)]="publicservice.code4"/>
        <input type="tel" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}"
               (keyup)="onDigitInput($event)" [(ngModel)]="publicservice.code5"/>
        <input type="tel" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}"
               (keyup)="onDigitInput($event)" [(ngModel)]="publicservice.code6" (ngModelChange)='onChange($event)'/>
      </div>
      <div style="padding-top: 20px;">
        <p [class]="key3"
           style="font-family: iransans;color: #ff5656;float: center;text-align: center;padding-top: 20px;">
          کد وارد شده غلط است</p>
      </div>
      <button class="btn btn-primary btn-embossed"
              (click)="sixdigit()">{{publicservice.Texts.Texts["six-digit2"]}}</button>
    </div>

    <div>
      <a (click)="taqirClick()">{{publicservice.Texts.Texts["six-digit4"]}}</a>
    </div>
    <!-- <img src="http://jira.moovooz.com/secure/attachment/10424/VmVyaWZpY2F0aW9uLnN2Zw==" alt="test" /> -->
  </div>

</div>

<div class="footer">
  <div style="display: flex;text-align: center;justify-content: center;">
    <p style="font-weight: bold;padding-right: 5px;"><a href="https://karinco.ir" style="color: #000;">کارین</a></p>
    <p> طراحی و پیاده سازی توسط شرکت</p>
  </div>
</div>

<!-- <div class="mb-2 digit-insert d-flex align-items-center">
    <div class="confirmation-group d-flex">
        <input #digitOne type="text"  maxlength="1"  (keyup)="onDigitInput($event)" />
        <input #digitTwo type="text" maxlength="1" (keyup)="onDigitInput($event)" />
        <input #digitThree type="text" maxlength="1" (keyup)="onDigitInput($event)" />
    </div>
    <span class="confirmation-divider m-3">-</span>
    <div class="confirmation-group d-flex">
        <input #digitFour type="text" maxlength="1" (keyup)="onDigitInput($event)" />
        <input #digitFive type="text" maxlength="1" (keyup)="onDigitInput($event)" />
        <input #digitSix type="text" maxlength="1" (keyup)="onDigitInput($event)" />
    </div>
  </div> -->
